<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="box" style="margin-right: 10px;">
          <div class="title">热门品牌</div>
          <div class="filter">
            起止时间：
            <el-date-picker
              style="margin: 0 10px"
              size="small"
              class="date-input"
              v-model="brandDate"
              type="daterange"
              align="right"
              unlink-panels
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-input
              class="input"
              v-model="brandName"
              placeholder="输入品牌名"
              size="small"
            ></el-input>
            <div class="btn" @click="getPortraitByBrand">查询</div>
          </div>
          <div class="list">
            <div class="item list-header">
              <div class="name">品牌名称</div>
              <div class="num">点击次数</div>
              <div class="num">点击人数</div>
            </div>
            <div class="item" v-for="(item, index) in brandList" :key="index">
              <div class="name">{{item.brandName}}</div>
              <div class="num">{{item.clicksNumber}}</div>
              <div class="num">{{item.clicksPeople}}</div>
            </div>
          </div>
        </div>
        <div class="box" style="margin-right: 10px;">
          <div class="title">热门产品</div>
          <div class="filter">
            起止时间：
            <el-date-picker
              style="margin: 0 10px"
              size="small"
              class="date-input"
              v-model="productDate"
              type="daterange"
              align="right"
              unlink-panels
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-input
              class="input"
              v-model="productName"
              placeholder="输入产品名"
              size="small"
            ></el-input>
            <div class="btn" @click="getPortraitByProduct">查询</div>
          </div>
          <div class="list">
            <div class="item list-header">
              <div class="name">产品名称</div>
              <div class="num">点击次数</div>
              <div class="num">点击人数</div>
            </div>
            <div class="item" v-for="(item, index) in productList" :key="index">
              <div class="name">{{item.name}}</div>
              <div class="num">{{item.clicksNumber}}</div>
              <div class="num">{{item.clicksPeople}}</div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="title">轮播图</div>
          <div class="banner-list">
            <div class="item" v-for="(item, index) in bannerList">
              <img :src="item.pic" alt="" class="pic">
              <div class="info">
                <div class="name">{{item.name}}</div>
                <div class="num-box">
                  <div class="num-item">
                    点击次数
                    <span>{{item.clicksNumber}}</span>
                  </div>
                  <div class="num-item">
                    点击人数
                    <span>{{item.clicksPeople}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: ' '
      },
      brandDate: [],
      productDate: [],
      brandName: '',
      productName: '',
      brandList: [],
      productList: [],
      bannerList: []
    };
  },
  mounted() {
    // 获取列表
    this.getPortraitByBrand();
    this.getPortraitByProduct();
    this.getPortraitByBanner();
  },
  computed: {},
  methods: {
    // 获取轮播列表
    getPortraitByBrand() {
      this.loading++;
      this.httpGet(this.$root.getPortraitByBrand, {
        begin: this.brandDate[0] || '',
        end: this.brandDate[1] || '',
        brandName: this.brandName
      }).then(
        (res) => {
          this.loading--;
          this.brandList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getPortraitByProduct() {
      this.loading++;
      this.httpGet(this.$root.getPortraitByProduct, {
        begin: this.productDate[0] || '',
        end: this.productDate[1] || '',
        productName: this.productName
      }).then(
        (res) => {
          this.loading--;
          this.productList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getPortraitByBanner() {
      this.loading++;
      this.httpGet(this.$root.getPortraitByBanner, {}).then(
        (res) => {
          this.loading--;
          this.bannerList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      // padding: 24px 32px;
      border-radius: 2px;
      flex-x(flex-start, flex-start);
      .box{
        height: 100%;
        flex-y(flex-start, flex-start);
        border-radius: 10px;
        overflow: hidden;
        flex: 1;
        // width: 1/ 3 * 100%;
        min-width: 500px;
        .title{
          width: 100%;
          height: 60px;
          flex-x();
          background: #fff;
          padding: 0 16px;
          box-sizing: border-box;
        }
        .filter{
          flex-x();
          background: #fff;
          padding: 0 16px 20px;
          box-sizing: border-box;
          white-space: nowrap;
          .date-input{
            width: 220px;
          }
          .input{
            width: 125px;
          }
          .btn{
            width: 60px;
            height: 32px;
            border-radius: 4px;
            background: #1890ff;
            cursor: pointer;
            word(14px, #fff);
            flex-x(center);
            margin-left: 5px;
          }
        }
        .list{
          width: 100%;
          flex: 1;
          background: #fff;
          margin-top: 1px;
          flex-y(flex-start);
          // background: red;
          overflow-y: auto;
          padding-left: 24px;
          padding-right: 12px;
          box-sizing: border-box;
          .item{
            width: 100%;
            height: 36px;
            flex-x();
            word(14px, #333);
            .name{
              flex: 1;
            }
            .num{
              width: 120px;
              flex-x(center);
            }
          }
          .list-header{
            word(14px, #666);
          }
        }
        .banner-list{
          width: 100%;
          background: #fff;
          flex-y(flex-start, flex-start);
          padding: 0 15px 30px;
          box-sizing: border-box;
          .item{
            width: 100%;
            height: 100px;
            background: #F7F7F7;
            margin-top: 10px;
            flex-x();
            padding: 10px;
            box-sizing: border-box;
            border: 1px solid #E3E3E3;
            border-radius: 5px;
            .pic{
              width: 220px;
              height: 80px;
              background: #fff;
            }
            .info{
              flex: 1;
              height: 100%;
              padding: 6px 0;
              padding-right: 20px;
              box-sizing: border-box;
              flex-y(flex-start, flex-start);
              margin-left: 12px;
              .name{
                word(14px, #333);
              }
              .num-box{
                width: 100%;
                margin-top: 16px;
                flex-x();
                .num-item{
                  flex-y();
                  flex: 1;
                  word(12px, #666);
                  span{
                    word(16px, #333);
                    margin-top: 6px;
                  } 
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
